import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package, Tags, MessageSquare, MailOpen } from "lucide-react";
import api from "@/lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data));
  }, []);

  const cards = [
    { label: "Ürünler", icon: Package, key: "products", to: "/admin/urunler", color: "#0066FF" },
    { label: "Kategoriler", icon: Tags, key: "categories", to: "/admin/kategoriler", color: "#0A2540" },
    { label: "Toplam Mesaj", icon: MessageSquare, key: "messages", to: "/admin/mesajlar", color: "#0066FF" },
    { label: "Okunmamış", icon: MailOpen, key: "unread_messages", to: "/admin/mesajlar", color: "#0A2540" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="heading-font text-3xl text-[#0A2540] mb-2">Hoş geldiniz</h1>
      <p className="text-slate-500 mb-10">Güven Kimya yönetim panelinizdesiniz.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c) => (
          <Link
            key={c.key}
            to={c.to}
            className="bg-white border border-slate-200 hover:border-[#0066FF] p-6 transition-colors"
            data-testid={`admin-stat-${c.key}`}
          >
            <c.icon size={24} style={{ color: c.color }} className="mb-4" />
            <div className="text-sm text-slate-500 uppercase tracking-wider">{c.label}</div>
            <div className="heading-font text-3xl text-[#0A2540] mt-2">
              {stats ? stats[c.key] : "-"}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
